module.exports = __webpack_public_path__ + "static/media/ic_calendar-gray0.5e192461.svg";